import React from 'react';
import { RefreshCw, CheckCircle } from 'lucide-react';
import { Badge } from '../../components/ui/Badge';

const VARIANT_COLOR = {
  transit:   '#0369a1',
  delivered: '#059669',
  incident:  '#e11d48',
  pending:   '#d97706',
  paid:      '#059669',
  overdue30: '#ea580c',
  overdue60: '#e11d48',
};

export function DashHeader({ title, sub, onRefresh, loading }) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h2 className="text-xl font-semibold text-slate-800">{title}</h2>
        {sub && <p className="text-[12.5px] text-slate-500 mt-0.5">{sub}</p>}
      </div>
      <button
        onClick={onRefresh}
        disabled={loading}
        className="h-8 px-3 flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white text-[12px] font-medium text-slate-600 hover:bg-slate-50 disabled:opacity-50 transition"
      >
        <RefreshCw size={13} strokeWidth={1.75} className={loading ? 'animate-spin' : ''} />
        Actualiser
      </button>
    </div>
  );
}

export function DashError({ message, onRetry }) {
  return (
    <div className="bg-rose-50 border border-rose-200 rounded-xl px-4 py-3 flex items-center justify-between text-[13px] text-rose-700">
      <span>{message}</span>
      <button onClick={onRetry} className="font-medium underline text-[12px]">
        Réessayer
      </button>
    </div>
  );
}

export function StatusBreakdown({ items, total }) {
  return (
    <div className="space-y-2.5">
      {items.map((item) => {
        const pct = total > 0 ? Math.round((item.count / total) * 100) : 0;
        const color = VARIANT_COLOR[item.variant] || '#94a3b8';
        return (
          <div key={item.label} className="flex items-center gap-2">
            <div className="w-28 shrink-0">
              <Badge variant={item.variant}>{item.label}</Badge>
            </div>
            <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-500"
                style={{ width: `${pct}%`, backgroundColor: color }}
              />
            </div>
            <span className="text-[12px] font-semibold text-slate-700 tabular-nums w-6 text-right">
              {item.count}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export function MiniEmpty({ label = 'Aucune donnée', ok = false }) {
  return (
    <div className="py-8 flex flex-col items-center gap-2 text-slate-400">
      {ok && <CheckCircle size={18} strokeWidth={1.5} className="text-emerald-400" />}
      <p className="text-[12.5px]">{label}</p>
    </div>
  );
}
